import GameBannerPage from './GameBannerPage'

export default GameBannerPage